export const SET_SCHEDULED_REPORTS = 'SET_SCHEDULED_REPORTS'
export const RESET_SCHEDULED_REPORTS = 'RESET_SCHEDULED_REPORTS'